import requset from "utils/request";
import baseURL from '@/api/env.js'
// 书籍详情
/* shelf */
export function homeShelfApi(params) {
    return requset({
        url: `${baseURL.AHEAD}/book/cdn/home`,
        method: "GET",
        params
    });
}
// //=====cdn
// export function BookDetail(bookId) {
//   return requset({
//     url: `${baseURL.AHEAD}/cdn/pc/${bookId}`,
//     method: "GET"
//   });
// }
// // 书籍目录
// export function Bookmenu(params) {
//   return requset({
//     url: `${baseURL.AHEAD}/cdn/menu`,
//     method: "GET",
//     params
//   });
// }
// // 书籍内容
// // ==========免费章节接口cdn
// export function chapterCon(params) {
//   return requset({
//     url: `${baseURL.AHEAD}/cdn/pc/chapter`,
//     method: "GET",
//     params
//   });
// }

// /* 收费 */
// export function chapternoCon(params) {
//   return requset({
//     url: `${baseURL.AHEAD}/cdn/pc/chapter`,
//     method: "GET",
//     params
//   });
// }
// /* 添加阅读记录 */
// export function addreadhistory(params) {
//   return requset({
//     url: `${baseURL.AHEAD}/read/record/add`,
//     method: "POST",
//     params
//   });
// }
// // 阅读历史
// export function readhistory(params) {
//   return requset({
//     url: `${baseURL.AHEAD}/read/record/list`,
//     method: "GET",
//     params
//   });
// }
// export function lasthistory(params) {
//   return requset({
//     url: `${baseURL.AHEAD}/read/record/last`,
//     method: "GET",
//     params
//   });
// }
// // 移除阅读
// export function deletehistory(params) {
//   return requset({
//     url: `${baseURL.AHEAD}/read/record/del`,
//     method: "POST",
//     params
//   });
// }
// // 加入书架
// export function addshelf(params) {
//   return requset({
//     url: `${baseURL.AHEAD}/user/shelf/add`,
//     method: "POST",
//     params
//   });
// }
// // 获取书架列表
// export function getshelf(params) {
//   return requset({
//     url: `${baseURL.AHEAD}/user/shelf/list`,
//     method: "GET",
//     params
//   });
// }
// // 获取最近最新加入的书
// export function getNewBook() {
//   return requset({
//     url: `${baseURL.AHEAD}/user/shelf`,
//     method: "GET"
//   });
// }
// // 移除书架
// export function deleteshelf(params) {
//   return requset({
//     url: `${baseURL.AHEAD}/user/shelf/del`,
//     method: "POST",
//     params
//   });
// }
// /* 首页书架 */
// export function getBookList(params) {
//   return requset({
//     url: `${baseURL.AHEAD}/core/pc/open/book/list`,
//     method: "GET",
//     params
//   });
// }
// /* 获取某本书的阅读状态---个人--非cdn */
// export function readstatus(params) {
//   return requset({
//     url: `${baseURL.AHEAD}/read/record/status`,
//     method: "GET",
//     params
//   });
// }
// /* 购买章节 */

// export function buyChapter(params) {
//   return requset({
//     url: `${baseURL.AHEAD}/core/pc/chapter/buy`,
//     method: "POST",
//     params
//   });
// }
// /* 获取章节浏览数 */
// export function chapterVisitor(params) {
//   return requset({
//     url: `${baseURL.AHEAD}/core/pc/chapter/visitor`,
//     method: "POST",
//     params
//   });
// }
// /* 是否开启自动订阅 */
// export function buyAuto(params) {
//   return requset({
//     url: `${baseURL.AHEAD}/read/record/autoSubScribe`,
//     method: "POST",
//     params
//   });
// }


// export function moreshelf(params) {
//   return requset({
//     url: `${baseURL.AHEAD}/cdn/shelf`,
//     method: "GET",
//     params
//   });
// }

// export function getOpenStatus(bookid) {
//   return requset({
//     url: `${baseURL.AHEAD}/book/book/open/status/${bookid}`,
//     method: "GET"
//   });
// }
